import { ITopologyConfigurationBuilderBase } from "./ITopologyConfigurationBuilderBase.js";

export interface IShardTopologyConfigurationBuilder extends ITopologyConfigurationBuilderBase<IShardTopologyConfigurationBuilder> {

}
